<template>
    <div>
        <div>
            <!-- SELECT LABEL -->
            <el-form-item
                :label="$t.__('dashboard.forms.TaskSettingForm.label_to_display')"
                prop="labels"
            >
                <el-select v-model="form.labels" multiple class="wp-4">
                    <el-option
                        v-for="label in labels"
                        :key="label.id"
                        :label="label.value"
                        :value="label.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';

export default {
    mixins: [SettingsFormMixin],
    data() {
        return {
            labels: [],
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
        this.$ajax.get('/rest/task/label', {}, (data) => {
            this.labels = data;
            this.$emit('updateLoading', { loading: false });
        });
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
    },
};
</script>
